const apiUrl = window._env_.REACT_APP_API_URL || '';
const homeUrl = window._env_.REACT_APP_HOME_URL || 'https://shahdana.evand.com';
const evandUrl = window._env_.REACT_APP_EVAND_URL || 'https://evand.com';
const panelUrl = window._env_.REACT_APP_PANEL_URL || 'https://panel.evand.com';
const apiAdminPanelUrl =
  window._env_.REACT_APP_API_ADMIN_PANEL_URL || 'https://api.evand.com/admin';
const circlesApiUrl = window._env_.REACT_APP_CIRCLES_API_URL || 'https://api-circle.evand.com';
const isProduction = window._env_.REACT_APP_ENV_TYPE === 'production';
const isStaging = window._env_.REACT_APP_ENV_TYPE === 'staging';

function setCookieOption() {
  if (isProduction) {
    return { maxAge: 3600, domain: '.evand.com' };
  }
  if (isStaging) {
    return { maxAge: 3600, domain: '.darkube.app' };
  }
  return { maxAge: 3600 };
}
const cookieOptions = setCookieOption();

export { apiUrl, circlesApiUrl, evandUrl, homeUrl, panelUrl, apiAdminPanelUrl, cookieOptions };
